<template>
  <v-form>
    <v-row>
      <v-col cols="6">
        <v-text-field name="customerRequestName" outlined dense label="Customer" v-model="record.Name"></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field name="customerRequestPhone" outlined dense label="Phone" v-model="record.PhoneNumber"></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field name="customerRequestProduct" outlined dense label="Product" v-model="record.ItemName"></v-text-field>
      </v-col>

      <v-col cols="6">
        <v-text-field name="customerRequestPrice" outlined dense label="Price Offered" v-model="record.Offer"></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn color="accent" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>
      </v-col>
    </v-row>
    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>

<script>
import snackbar from '../../../global/snackbar.vue';
export default {
  components: { snackbar },
  props: {
    initial: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    record: {},
    loader: false,
    date: new Date().toISOString().substr(0, 10),
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true,
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (
        this.record.Name == undefined ||
        this.record.PhoneNumber == undefined ||
        this.record.ItemName == undefined
      ) {
        this.$refs.snackbar.show(
          "Customer Name, Phone Number and Product are mandatory!",
          "red"
        );
      } else {
        this.$store.commit("btnLoader", true);
        this.$emit("data", this.record);
      }
    },
  },
};
</script>